import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import ListIccidPage from './ListIccidPage';
import { startFetchUserDetails, saveSelectedProfile } from '../../actions/basicAction';
import { ESimProfiles } from '../../reducers/user';

export const mapStateToProps = (state: AppState) => {
    return {
        eSimProfiles: state.user.userDetails!!.esimProfiles,
        buttonElement: 'Next',
        selectedEsimProfiles: state.user.selectedEsimProfiles
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {
        onChange: (eSimProfiles: ESimProfiles) => {
            dispatch(saveSelectedProfile(eSimProfiles));
        },
        onSubmit: () => {
            // dispacth();
            dispatch(startFetchUserDetails);
        }
    };
};

const ListIccidPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ListIccidPage);

export default ListIccidPageContainer;



// WEBPACK FOOTER //
// ./src/components/listIccids/ListIccidPageContainer.tsx